import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Art from './pages/Art';
import SoftwareProjects from './pages/SoftwareProjects';
import Contact from './pages/Contact';
import './App.css';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Router>
      <div>
        <header className="app-header">
          <Link to="/" className="logo-link">
            <img src="/realseal.png" alt="Logo" className="logo" />
          </Link>
          <button 
            className="menu-icon" 
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
          {menuOpen && (
            <nav className="menu-dropdown">
              <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
              <div className="menu-item-parent">Portfolio</div>
              <Link to="/portfolio/art" onClick={() => setMenuOpen(false)} className="menu-item-sub">Art</Link>
              <Link to="/portfolio/software-projects" onClick={() => setMenuOpen(false)} className="menu-item-sub">Software Projects</Link>
              <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>
            </nav>
          )}
        </header>

        <main style={{ paddingTop: '80px' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio/art" element={<Art />} />
            <Route path="/portfolio/software-projects" element={<SoftwareProjects />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
